export enum CompanyAccountState {
    Draft = 'Draft',
    BuyPlan = 'BuyPlan',
    CompleteProfile = 'CompleteProfile',
    UnderReview = 'UnderReview',
    Rejected = 'Rejected',
    Active = 'Active',
    Canceled = 'Canceled'
}